import { reatomAsync, withDataAtom } from "@reatom/async";
import { PromotionAwardRequestDtoTypeEnum } from "definitions/poizon-bff";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";
import { toastHandler } from "src/util";

export const getPromotionAwardRequest = reatomAsync(
  async (ctx, type: PromotionAwardRequestDtoTypeEnum) => {
    const response = await API.promotionApi.promotionControllerPromotionAward(
      {
        type,
      },
      {
        validateStatus: (status) => status === 200 || status === 201,
      },
    );

    if (response.status === 201 || response.status === 200) {
      toastHandler.success({
        title: `Акция`,
        content: response.data?.message,
        name: "PromotionSuccessResponse",
      });
      return null;
    }

    return { status: response.status, message: response.data.message };
  },
  { name: "getPromotionAwardRequest" },
).pipe(withDataAtom(null), withIsLoadingAtom());
